import Reveal from '@/components/feature/Reveal';
import SectionHeader from './SectionHeader';

const cases = [
  {
    icon: 'ri-flow-chart',
    title: 'Automatizar procesos',
    desc: 'Convierte tareas manuales y repetitivas en procesos automáticos.',
  },
  {
    icon: 'ri-git-merge-line',
    title: 'Conectar tu ERP',
    desc: 'Integra SAP Business One u otros sistemas con aplicaciones, APIs y servicios externos.',
  },
  {
    icon: 'ri-rocket-2-line',
    title: 'Crear un SaaS',
    desc: 'Transforma una idea o sistema interno en una plataforma comercial escalable.',
  },
  {
    icon: 'ri-brain-line',
    title: 'Incorporar IA',
    desc: 'Conecta agentes inteligentes con información y procesos reales de tu organización.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Modernizar sistemas',
    desc: 'Evoluciona aplicaciones antiguas hacia arquitecturas modernas.',
  },
  {
    icon: 'ri-box-3-line',
    title: 'Crear un producto digital',
    desc: 'Desde arquitectura y desarrollo hasta infraestructura y puesta en producción.',
  },
];

export default function UseCases() {
  return (
    <section className="relative py-20 md:py-28 bg-background-900/40 border-y border-background-800/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Casos de uso"
          title="¿Qué podemos construir para tu empresa?"
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cases.map((c, i) => (
            <Reveal key={c.title} delay={i * 60}>
              <div className="group h-full rounded-lg border border-background-700/60 bg-background-950/60 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/40 cursor-pointer">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-background-800 border border-background-700/60 text-primary-400 group-hover:text-primary-300 transition-colors">
                  <i className={`${c.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 text-base md:text-lg font-bold font-heading text-foreground-950">
                  {c.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {c.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}